import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Row, Button } from "react-bootstrap";
import { FaPlay } from "react-icons/fa";
import RecordButton from "./RecordButton";
import { setTranscript } from "../../../../../store/actions";
import { useChatActions } from "../../../../../hooks/useChatActions";

const ChatInput = () => {
  const dispatch = useDispatch();
  const transcript = useSelector((state) => state.transcript);
  const typePlaceholder = useSelector((state) => state.typePlaceholder);
  const isLoading = useSelector((state) => state.isLoading);
  const { handleSubmit } = useChatActions();

  return (
    <Row>
      <Form>
        <div className="input-box">
          <Form.Control
            as="textarea"
            rows={2}
            value={transcript}
            onChange={(e) => dispatch(setTranscript(e.target.value))}
            placeholder={typePlaceholder}
            id="textarea-field"
            onKeyDown={handleSubmit}
            disabled={Object.values(isLoading).some((val) => val)}
          />

          {transcript.length === 0 ? (
            <RecordButton />
          ) : (
            <Button
              variant="dark"
              size="lg"
              className="chat-button"
              onClick={handleSubmit}
              disabled={Object.values(isLoading).some((val) => val)}
            >
              <FaPlay />
            </Button>
          )}
        </div>
      </Form>
    </Row>
  );
};

export default ChatInput;
